import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { LineChart, ArrowRight } from "lucide-react";
import { trackEvent } from "@/lib/trackEvent";

interface Props {
  coin?: string | null;
  articleId?: string;
  slug?: string;
}

export default function InlineCoinAnalysisCard({ coin, articleId, slug }: Props) {
  const href = coin ? `/coin-reviewer?coin=${encodeURIComponent(coin)}` : "/coin-reviewer";

  return (
    <Card className="not-prose my-10 p-5 sm:p-6 border-border/60 bg-card/60">
      <div className="flex items-start gap-3 mb-3">
        <div className="w-9 h-9 rounded-lg bg-primary/15 flex items-center justify-center flex-shrink-0">
          <LineChart className="w-4 h-4 text-primary" />
        </div>
        <div>
          <p className="text-xs uppercase tracking-wider text-muted-foreground font-semibold">
            Related Coin Analysis
          </p>
          <h4 className="text-lg font-bold leading-snug">
            {coin
              ? `Run a full AI due-diligence review on ${coin}`
              : "Run a full AI due-diligence review on any coin"}
          </h4>
        </div>
      </div>
      <p className="text-sm sm:text-base text-muted-foreground mb-4">
        Fundamentals, momentum, risk profile and a plain-English verdict in about 30 seconds.
      </p>
      <Button
        asChild
        variant="secondary"
        onClick={() =>
          trackEvent("cta_clicked_to_coin_reviewer", {
            placement: "inline_card",
            coin: coin ?? null,
            article_id: articleId,
            slug,
          })
        }
      >
        <Link to={href}>
          {coin ? `Analyze ${coin}` : "Open Coin Reviewer"}
          <ArrowRight className="w-4 h-4 ml-2" />
        </Link>
      </Button>
    </Card>
  );
}
